





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Workorder, WorkorderPagedCollectionApiResponse } from 'performo-api';

@Component({})
export default class FoundSetNavigation extends Vue {
  @Prop({ required: false }) pagedOrders!: WorkorderPagedCollectionApiResponse;
  @Prop({ required: true }) private currentOrder!: Workorder;

  private currentIndex!: number;
  private indexPosInPage!: string;
  private orderPosition!: number;
  private orderPositionDisplay!: string;
  private loading!: boolean;

  data() {
    return {
      orderPositionDisplay: this.orderPositionDisplay,
      loading: this.loading
    };
  }

  mounted() {
    this.findCurrentOrderPosition();
  }

  @Watch('currentOrder')
  private findCurrentOrderPosition() {
    if (this.pagedOrders.data) {
      // get index position of the order in current page
      this.currentIndex = this.pagedOrders.data.findIndex(
        (o) => o.workorderId === this.currentOrder.workorderId
      );
      // get overall position of the order in the entire found set
      if (
        this.pagedOrders.pagination &&
        this.pagedOrders.pagination.pageNumber &&
        this.pagedOrders.pagination.pageSize
      ) {
        this.orderPosition =
          // eslint-disable-next-line prettier/prettier
          (this.pagedOrders.pagination.pageNumber - 1) *
            this.pagedOrders.pagination.pageSize +
          (this.currentIndex + 1);
      }
    }

    this.buildOrderPositionDisplay();
  }

  private buildOrderPositionDisplay() {
    this.orderPositionDisplay =
      this.orderPosition + ' / ' + this.pagedOrders.pagination?.totalItems;
    this.loading = false;
  }

  @Watch('pagedOrders.pagination.pageNumber')
  private loadOrder() {
    if (!this.loading) {
      if (this.indexPosInPage === 'start') {
        this.currentIndex = 0;
      } else if (
        this.indexPosInPage === 'end' &&
        this.pagedOrders.pagination?.itemsInPage
      ) {
        this.currentIndex = this.pagedOrders.pagination?.itemsInPage - 1;
      }
      this.indexPosInPage = '';
      this.$emit('load-master-detail-order', this.currentIndex);
      this.loading = true;
    }
  }

  private loadFirstOrder() {
    if (
      this.pagedOrders.pagination?.pageNumber === 1 &&
      this.pagedOrders.data
    ) {
      this.loading = true;
      this.$emit('load-master-detail-order', 0);
    } else {
      this.$emit('update-pagination', 1);
    }
    this.indexPosInPage = 'start';
  }

  private loadLastOrder() {
    if (
      this.pagedOrders.pagination?.pageNumber ===
        this.pagedOrders.pagination?.totalPages &&
      this.pagedOrders.data &&
      this.pagedOrders.pagination?.itemsInPage
    ) {
      this.loading = true;
      this.currentIndex = this.pagedOrders.pagination?.itemsInPage - 1;
      this.$emit('load-master-detail-order', this.currentIndex);
    } else {
      if (this.pagedOrders.pagination?.totalPages) {
        this.$emit(
          'update-pagination',
          this.pagedOrders.pagination?.totalPages
        );
        this.indexPosInPage = 'end';
      }
    }
  }

  private loadPreviousOrder() {
    if (
      // if current index is not at first element of current page, decrement
      this.pagedOrders.data &&
      this.currentIndex > 0
    ) {
      --this.currentIndex;
      this.loading = true;
      this.$emit('load-master-detail-order', this.currentIndex);
    } else if (
      // if current index is at the first element of current page and
      // if current page is not the first page, load next previous page and set index to last element
      this.pagedOrders.pagination?.pageNumber &&
      this.pagedOrders.pagination.pageNumber > 1
    ) {
      this.goPageBackward();
    }
  }

  private loadNextOrder() {
    if (
      // if current index is not at last element of current page, increment
      this.pagedOrders.data &&
      this.currentIndex < this.pagedOrders.data.length - 1
    ) {
      ++this.currentIndex;
      this.loading = true;
      this.$emit('load-master-detail-order', this.currentIndex);
    } else if (
      // if current index is at the last element of current page &&
      // if current page is not the last page, load next page and set index to first element
      this.pagedOrders.pagination?.pageNumber &&
      this.pagedOrders.pagination.totalPages &&
      this.pagedOrders.pagination.pageNumber <
        this.pagedOrders.pagination.totalPages
    ) {
      this.goPageForward();
    }
  }

  private goPageBackward() {
    // do page forward things
    this.$emit(
      'update-pagination',
      (this.pagedOrders.pagination?.pageNumber || 1) - 1
    );
    this.indexPosInPage = 'end';
  }

  private goPageForward() {
    // do page forward things
    this.$emit(
      'update-pagination',
      (this.pagedOrders.pagination?.pageNumber || 1) + 1
    );
    this.indexPosInPage = 'start';
  }
}
